import {
    CLEAR_TRUNK_STATISTICS_FILTERS,
    SET_TRUNK_STATISTICS_UI_FILTERS,
    GET_TRUNK_STATISTIC,
    INITIAL_TRUNK_STATISTICS_DATA,
    SET_CURRENT_TRUNK_STATISTICS_PAGE,
    SET_CURRENT_TRUNK_STATISTICS_SIZE,
    SET_TRUNK_STATISTICS_FILTER,
    SET_TRUNK_STATISTICS_LOADING,
    SHOW_EXPORT_TRUNK_STATISTICS_LOADING,
    UPDATE_TRUNK_STATISTIC_FILTER,
    SET_CURRENT_TRUNK_STATISTICS_FILES_PAGE,
    SET_CURRENT_TRUNK_STATISTICS_FILES_SIZE,
} from "../types/typesTrunkStatisticsList";

export function setTrunkStatisticsCurrentPage(state: number) {
    return {
        type: SET_CURRENT_TRUNK_STATISTICS_PAGE,
        payload: state,
    };
}

export function setTrunkStatisticsCurrentPageSize(state: number) {
    return {
        type: SET_CURRENT_TRUNK_STATISTICS_SIZE,
        payload: state,
    };
}

export function showTrunkStatisticsLoader(state: boolean) {
    return {
        type: SET_TRUNK_STATISTICS_LOADING,
        payload: state,
    };
}

export function showTrunkStatisticsExportLoader(state: boolean) {
    return {
        type: SHOW_EXPORT_TRUNK_STATISTICS_LOADING,
        payload: state,
    };
}

export function setTrunkStatisticsFilter(payload: any) {
    return {
        type: SET_TRUNK_STATISTICS_FILTER,
        payload,
    };
}

export const updateTrunkStatisticFilter = (field: string, value: any) => ({
    type: UPDATE_TRUNK_STATISTIC_FILTER,
    payload: {field, value},
});

export const resetTrunkStatisticFilters = () => ({
    type: CLEAR_TRUNK_STATISTICS_FILTERS,
});

export function setTrunkStatisticsUiFilters(filters: Record<string, any>) {
    return {
        type: SET_TRUNK_STATISTICS_UI_FILTERS,
        payload: filters,
    };
}

export function getTrunkStatisticDetailsInfo(data: any) {
    return {
        type: GET_TRUNK_STATISTIC,
        payload: data,
    };
}

export function initialTrunkStatisticsData() {
    return {
        type: INITIAL_TRUNK_STATISTICS_DATA,
    };
}

export function setTrunkStatisticsFilesCurrentPage(state: number) {
    return {
        type: SET_CURRENT_TRUNK_STATISTICS_FILES_PAGE,
        payload: state,
    };
}

export function setTrunkStatisticsFilesCurrentPageSize(state: number) {
    return {
        type: SET_CURRENT_TRUNK_STATISTICS_FILES_SIZE,
        payload: state,
    };
}
